/** @see DesignModuleLink.sourcePort and @see DesignModuleLink.targetPort. */
export enum DesignModuleLinkPort {
  bottom = 'bottom',
  left = 'left',
  right = 'right',
  top = 'top'
}
